import * as React from 'react';
import {withRouter} from 'react-router-dom';
import {IProduct} from "../../functions/Interfaces";
import ProductCatalog from '../product/ProductCatalog';
import { Typography } from '@material-ui/core';

class SearchResults extends React.Component<any, { products: IProduct[] }> {
  public render() {
    const keyword: string = getKeywordfromRoute(this.props).toLowerCase();
    const searchRes: IProduct[] = getSearchResults(
      this.props.products,
      keyword
    );
    if (searchRes.length !== 0) {
      return (
        <div>
          <Typography color="secondary" align="center" variant="h2">
            Search Results
          </Typography>
          <ProductCatalog
            products={searchRes}
            actionUpdate={this.props.actionUpdate}
          />
        </div>
      );
    } else {
      return (
        <div>
          <p>
            Tut uns leid wir konnten leider keine Ergebnisse zu deiner Suche
            finden.
          </p>
        </div>
      );
    }
  }
}
export default withRouter(SearchResults);

function getSearchResults(products: IProduct[], keyword: string): IProduct[] {
  let res: IProduct[] = [];
  products.forEach((product: IProduct) => {
    if (product.name.toLocaleLowerCase().includes(keyword)) {
      res = res.concat(product);
    }
  });
  return res;
}

function getKeywordfromRoute(props: any): string {
  const pathname: string = props.location.pathname;
  const index: number = pathname.indexOf("=");
  const keyword: string = pathname.substr(index + 1);
  return keyword;
}


// WEBPACK FOOTER //
// ./src/components/searchresult/SearchResults.tsx